/**
 * Dinheiro na tela.
 *
 * O servidor manda CENTAVOS inteiros, igual ao notebook, e quem escreve o ponto e a vírgula
 * é a tela. Nunca o contrário: número com vírgula viajando entre programas é como se perde
 * um centavo por arredondamento, e num livro de tesouraria isso não se explica depois.
 */

/*
  DINHEIRO, MÊS E DATA VÊM DO NOTEBOOK desde a fase 3 do espelho (12/10/2026).

  Estas quatro funções eram cópias à mão das do programa de tesouraria. Elas são o que o pastor
  LÊ: se o painel escrever o dinheiro ou o nome do mês de um jeito e o notebook de outro, ele vê
  dois números e não tem como saber qual está certo.

  A cópia conferida mora em `src/compartilhado/`, e há prova que fica vermelha quando ela
  divergir do original. Os nomes daqui continuam os do painel, porque são eles que as telas
  usam; o que mudou foi de onde a conta vem.
*/
import { formatarReais } from '../../src/compartilhado/types'
import { competenciaPorExtenso as doNotebook, mesVizinho } from '../../src/compartilhado/datas'

export function emReais(centavos: number): string {
  return formatarReais(centavos)
}

/** `2026-09` vira `setembro de 2026`. */
export function competenciaPorExtenso(competencia: string): string {
  return doNotebook(competencia)
}

/** `2026-09` vira `2026-08`. O painel anda mês a mês para trás. */
export function mesAnterior(competencia: string): string {
  return mesVizinho(competencia, -1)
}

export function mesSeguinte(competencia: string): string {
  return mesVizinho(competencia, 1)
}

/** "2026-10-18 10:00:00", como o notebook escreve, em "18/10/2026". */
export function dataDoNotebook(quando: string): string {
  const [a, m, d] = quando.slice(0, 10).split('-')
  return a && m && d ? `${d}/${m}/${a}` : quando
}

/** As quatro situações do mês, escritas como o pastor fala. */
export const NOME_DA_SITUACAO: Record<string, string> = {
  ABERTO: 'aberto',
  FECHADO: 'fechado e assinado',
  TRAVADO: 'travado pelo Campo',
  NAO_FECHOU: 'não fechou'
}

/**
 * "há 12 dias", "hoje".
 *
 * `seNunca` existe porque a mesma conta serve ao último envio de um notebook e ao último
 * acesso de uma pessoa, e "nunca enviou" numa linha de pessoa sai errado. O retrato da tela de
 * Pessoas mostrou, com "último acesso: nunca enviou".
 */
export function quandoFoi(iso: string | null, seNunca = 'nunca enviou'): string {
  if (!iso) return seNunca
  const dias = Math.floor((Date.now() - new Date(iso).getTime()) / (24 * 60 * 60 * 1000))
  if (dias <= 0) return 'hoje'
  if (dias === 1) return 'ontem'
  return `há ${dias} dias`
}
